import { render, staticRenderFns } from "./OrdersChange.vue?vue&type=template&id=1b64086a&"
import script from "./OrdersChange.vue?vue&type=script&lang=js&"
export * from "./OrdersChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports